import { render, staticRenderFns } from "./TransportadoraManage.vue?vue&type=template&id=1f4eaa5c&scoped=true"
import script from "./TransportadoraManage.vue?vue&type=script&lang=js"
export * from "./TransportadoraManage.vue?vue&type=script&lang=js"
import style0 from "./TransportadoraManage.vue?vue&type=style&index=0&id=1f4eaa5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4eaa5c",
  null
  
)

export default component.exports